import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "~/atoms/breadcrumb";

interface Props {
  documentId: number;
  releaseId: number;
  name: string;
  additionalBreadcrumbs?: {
    label: string;
    to?: string;
  }[];
}

export function DocumentBreadcrumbs({
  documentId,
  releaseId,
  name,
  additionalBreadcrumbs = [],
}: Props) {
  const { t } = useTranslation();

  const documentLink = `/documents/${documentId}?releaseId=${releaseId}`;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/documents">{t(($) => $.library.header)}</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          {additionalBreadcrumbs.length > 0 ? (
            <BreadcrumbLink asChild>
              <Link to={documentLink}>{name}</Link>
            </BreadcrumbLink>
          ) : (
            <BreadcrumbPage className="flex items-center gap-4">
              {name}
            </BreadcrumbPage>
          )}
        </BreadcrumbItem>
        {additionalBreadcrumbs.map(({ label, to }, i) => {
          const content = to ? (
            <BreadcrumbLink asChild>
              <Link to={to}>{label}</Link>
            </BreadcrumbLink>
          ) : (
            <BreadcrumbPage>{label}</BreadcrumbPage>
          );

          return (
            <Fragment key={i}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>{content}</BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
